// The console's own "are you sure?" before an action that is hard to undo, in place of the browser's confirm()
// (Amine, 2026-10-22: "make the popup more professional"). One question at a time; ConfirmDialog, in the shell,
// shows it, and a newer question answers an unanswered one with no.
import { ref } from "vue";

export interface ConfirmAsk {
  title: string;      // the question: "Activate v1?"
  body?: string;      // what follows from it
  confirm: string;    // the button that does it, named for what it does: "Activate v1"
  cancel?: string;    // "Cancel" unless said
  danger?: boolean;   // removes or stops something: the button says so in red
}

interface Pending extends ConfirmAsk { resolve: (ok: boolean) => void }

const pending = ref<Pending | null>(null);

export function askConfirm(ask: ConfirmAsk): Promise<boolean> {
  pending.value?.resolve(false);
  return new Promise((resolve) => { pending.value = { ...ask, resolve }; });
}

export function answerConfirm(ok: boolean): void {
  const p = pending.value;
  pending.value = null;
  p?.resolve(ok);
}

export function useConfirm() {
  return { pending, ask: askConfirm, answer: answerConfirm };
}
